import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// Material Dashboard 2 React components
import { AuthContext } from "context";
import { createMRTColumnHelper } from "material-react-table";
import MDAlert from "../../components/MDAlert";
import MDTypography from "../../components/MDTypography";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import apiService from "../../services/api-service";
import showToast from "../../utils/toast";
import GenericTable from "../genericTable.js";

function MachineryManagement() {
	const authContext = useContext(AuthContext);
	const navigate = useNavigate();
	const [data, setData] = useState([]);

	const handleSetNotification = useCallback((msg, severityType) => {
		showToast(msg, severityType);
	}, []);

	const fetchData = useCallback(() => {
		apiService
			.get("/machineries-management/", {}, {})
			.then((data) => {
				setData(data);
			})
			.catch((error) => {
				handleSetNotification(
					"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supporto tecnico indicando l'errore #00090",
					"error"
				);
			});
	}, [handleSetNotification]);

	useEffect(() => {
		fetchData();
	}, [fetchData]);

	const columnHelper = createMRTColumnHelper();

	const handleEdit = (id) => {
		navigate(`edit/${id}`);
	};

	async function deleteResource(id) {
		try {
			const endpoint = `/machineries-management/`;
			const params = { id: id };
			const headers = {};
			const response = await apiService.delete(endpoint, params, headers);
			console.log(`Risorsa con id ${id} eliminata con successo:`, response);
			return response;
		} catch (error) {
			console.error(`Errore durante l'eliminazione della risorsa con id ${id}:`, error.message);
			throw error;
		}
	}

	function handleDelete(id) {
		if (
			window.confirm(
				"Sei sicuro di voler eliminare questo macchinario?\n Attenzione questa operazione è irreversibile."
			)
		) {
			deleteResource(id)
				.then((result) => {
					handleSetNotification("Macchinario eliminato con successo", "success");
					fetchData();
				})
				.catch((error) => {
					handleSetNotification(
						"Si è verificato un errore durante l'eliminazione del macchinario. Riprova più tardi se l'errore persiste contatta il supporto tecnico indicando l'errore #00091",
						"error"
					);
				});
		}
	}

	const columns = [
		columnHelper.accessor("name", {
			header: "Nome",
			size: 120,
		}),
		columnHelper.accessor("chassis_number", {
			header: "Numero Telaio",
			size: 120,
		}),
		columnHelper.accessor("supplier_name", {
			header: "Fornitore",
			size: 120,
		}),
	];

	return (
		<>
			<DashboardLayout>
				{authContext.hasAuth("VIEW_MACHINERY") ? (
					<>
						<DashboardNavbar />
						<GenericTable
							authModelName={"MACHINERY"}
							data={data}
							columns={columns}
							onDelete={handleDelete}
							onEdit={handleEdit}
							isAddRowEnabled={true}
						/>
					</>
				) : (
					<MDAlert color="error" dismissible>
						<MDTypography variant="body2">Non hai i permessi per accedere a questa pagina</MDTypography>
					</MDAlert>
				)}
			</DashboardLayout>
		</>
	);
}

export default MachineryManagement;
